import { ProfileAvatar } from '@care/react-component-lib';
import { useMediaQuery, type Theme } from '@mui/material';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';
import getUserInitials from '@/utils/getUserInitials';

interface CaregiverProfileAvatarProps {
  caregiver: Caregiver;
  isClientSearchResultsQuery: boolean;
}

const CaregiverProfileAvatar = ({
  caregiver,
  isClientSearchResultsQuery,
}: CaregiverProfileAvatarProps) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const {
    member: { displayName },
  } = caregiver;

  const imgSize = () => {
    return isMobileOrSmaller ? 'xLarge' : 'squareSmall';
  };

  const profileAvatarProps = {
    alt: `${displayName}'s Photo`,
    size: imgSize(),
    src: caregiver.member.imageURL ?? undefined,
    slotProps: {
      avatar: {
        imgProps: isClientSearchResultsQuery
          ? { loading: 'eager' as const }
          : { loading: 'lazy' as const },
      },
    },
  } as const;

  return <ProfileAvatar {...profileAvatarProps}>{getUserInitials(displayName)}</ProfileAvatar>;
};

export default CaregiverProfileAvatar;
